
export const getApiBaseUrl = () => {
  return process.env.REACT_APP_API_URL;
};

export const secondsToHms = (seconds) => {
  seconds = Number(seconds);
  //var h = Math.floor(seconds / 3600);
  var m = Math.floor((seconds % 3600) / 60);
  var s = Math.floor((seconds % 3600) % 60);

  var mDisplay = m > 0 ? m : "0"; //+ (m == 1 ? " minute, " : " minutes, ") : "";
  var sDisplay = s < 10 ? `0${s}` : s; //+ (s == 1 ? " second" : " seconds") : "";
  return `${mDisplay}:${sDisplay}`;
};

// method to get correct justification and alignent to make using flex easier
// eg: flex('row', bottom', 'right')
export const flex = (rowOrCol, verticalAlign, horizontalAlign) => {
  if (rowOrCol === "col") {
    rowOrCol = "column";
  }

  let justifyContent = "center";
  let alignItems = "center";

  switch (verticalAlign) {
    case "bottom":
      justifyContent = "flex-end";
      break;

    case "top":
      justifyContent = "flex-start";
      break;

    default:
      justifyContent = "flex-start";
      break;
  }

  switch (horizontalAlign) {
    case "right":
      alignItems = "flex-end";
      break;

    case "left":
      alignItems = "flex-start";
      break;

    default:
      alignItems = "flex-end";
      break;
  }

  if (rowOrCol === "row") {
    let temp = alignItems;
    alignItems = justifyContent;
    justifyContent = temp;
  }

  return { justifyContent, alignItems, flexDirection: rowOrCol };
};
